import React, { useMemo } from 'react';
import { Marker, Polyline, Popup } from 'react-leaflet';

import { segmentsJusqua } from '../../lib/arretsTrajet';
import { formatDateHeure } from '../../lib/formats';
import { arretIcon } from './icons';
import { dureeArretTexte } from './fleetRules';

/** Une couleur par classe de vitesse; les mêmes que dans l'aide du bouton. */
export const COULEURS_VITESSE = {
  arret: 'hsl(var(--muted-foreground))',
  normal: 'hsl(var(--success))',
  rapide: 'hsl(var(--flame))',
  exces: 'hsl(var(--destructive))',
};

/**
 * Ce que la lecture d'un trajet dessine sur la carte: la trace colorée selon
 * la vitesse (pâle devant le camion, pleine derrière) et les arrêts numérotés.
 * Le camion lui-même est posé par la page.
 */
export default function CoucheRejeu({ segments, arrets, index }) {
  const parcourus = useMemo(() => segmentsJusqua(segments, index), [segments, index]);
  return (
    <>
      {segments.map((segment) => (
        <Polyline
          key={`avenir-${segment.debut}`}
          positions={segment.positions}
          color={COULEURS_VITESSE[segment.classe]}
          weight={4}
          opacity={0.25}
          interactive={false}
        />
      ))}
      {parcourus.map((segment) => (
        <Polyline
          key={`fait-${segment.debut}`}
          positions={segment.positions}
          color={COULEURS_VITESSE[segment.classe]}
          weight={5}
          opacity={0.95}
          interactive={false}
        />
      ))}
      {arrets.map((arret, rang) => (
        <Marker
          key={`arret-${arret.index}`}
          position={[arret.latitude, arret.longitude]}
          icon={arretIcon(rang + 1)}
        >
          <Popup>
            <div className="text-sm">
              <p className="font-bold">Arrêt n° {rang + 1}</p>
              <p>Arrivée : {formatDateHeure(arret.debut)}</p>
              <p>Durée : {dureeArretTexte(arret.dureeS)}</p>
            </div>
          </Popup>
        </Marker>
      ))}
    </>
  );
}
